import { User } from '@sentry/angular';

export const isUserMissingData = (user: User): boolean => {
  const { country, email, first_name, last_name } = user;

  return !country || !email || !first_name || !last_name;
};
